import json_editor from 'json-editor'

import schema from './schema.json'
import data from '@/assets/data.json'

export default  {
  name: 'admin',
  props: [],
  data() {
    return {}
  },
  mounted() {

    this.editor = new JSONEditor(this.$refs.editor, {
      schema: schema,
      theme: "bootstrap3",
      disable_edit_json: true,
      disable_collapse: true,
      disable_properties: true
    });

    this.editor.setValue(data);
  },
  methods: {
    _onClickDump() {
      window.dump = this.editor.getValue();
      console.info('now run \'copy(dump)\'');
    }
  }
}




// WEBPACK FOOTER //
// ./src/components/admin/admin.component.js